import { Info } from 'lucide-react'
import type React from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~/shadcn/ui/tooltip'

export function CommonTooltip({
  content,
  color,
  tooltipMode,
  icon,
}: {
  content: string | React.ReactNode
  color?: string
  tooltipMode?: 'light' | 'dark'
  icon?: React.ReactNode
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="p-0 h-auto self-center focus-visible:ring-0 focus-visible:ring-offset-0">
            {icon ?? (
              <Info
                className="w-4 h-4 text-[#3D3D3D]"
                style={{
                  color,
                }}
              />
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent tooltipMode={tooltipMode}>
          {typeof content === 'string' ? (
            <p className="text-[13px] font-semibold leading-normal">
              {content}
            </p>
          ) : (
            content
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
